import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  OrderRecalcHistoryItem,
  OrderRecalcLineDelta,
  OrderService
} from 'src/entities/order';

@Component({
  selector: 'app-order-recalc-history-dialog',
  templateUrl: './order-recalc-history-dialog.component.html',
  styleUrls: ['./order-recalc-history-dialog.component.css']
})
export class OrderRecalcHistoryDialogComponent implements OnInit {
  items: OrderRecalcHistoryItem[] = [];
  loading = true;
  error = '';

  constructor(
    private readonly orderService: OrderService,
    private readonly dialogRef: MatDialogRef<OrderRecalcHistoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      orderId: string;
      lastRecalculatedAt?: string | null;
      autoAdjusted?: boolean;
    }
  ) {}

  ngOnInit(): void {
    this.orderService.getOrderRecalcHistory(this.data.orderId).subscribe({
      next: (items) => {
        this.items = items ?? [];
        this.loading = false;
      },
      error: () => {
        this.error = 'No se pudo leer el historial.';
        this.loading = false;
      }
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  triggerLabel(trigger: string): string {
    const labels: Record<string, string> = {
      PAX_CHANGE: 'Cambio de pasajeros',
      TARIFF_CHANGE: 'Cambio de tarifa',
      FREEZE: 'Plazo para confirmar',
      MANUAL: 'Manual'
    };
    return labels[trigger] || trigger;
  }

  sourceLabel(source: string): string {
    const labels: Record<string, string> = {
      AUTO: 'Automático',
      USER: 'Usuario',
      FREEZE: 'Plazo para confirmar'
    };
    return labels[source] || source;
  }

  wentDown(previous: number | null | undefined, next: number | null | undefined): boolean {
    return previous != null && next != null && next < previous;
  }

  wentUp(previous: number | null | undefined, next: number | null | undefined): boolean {
    return previous != null && next != null && next > previous;
  }

  lineAmounts(item: OrderRecalcHistoryItem): OrderRecalcLineDelta[] {
    const lines = item.lineDeltas || [];
    if (lines.length !== 1) {
      return lines;
    }
    const line = lines[0];
    if (
      line.previousAmount === item.previousTotal &&
      line.newAmount === item.newTotal
    ) {
      return [];
    }
    return lines;
  }

  paxChanges(item: OrderRecalcHistoryItem): OrderRecalcLineDelta[] {
    return (item.lineDeltas || []).filter(
      (line) =>
        (line.previousPax != null || line.newPax != null) &&
        line.previousPax !== line.newPax
    );
  }
}
